import { render, staticRenderFns } from "./ingredientsList.vue?vue&type=template&id=3a6d1ac8"
import script from "./ingredientsList.vue?vue&type=script&lang=js"
export * from "./ingredientsList.vue?vue&type=script&lang=js"
import style0 from "./ingredientsList.vue?vue&type=style&index=0&id=3a6d1ac8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports